import { scroll } from "motion";

const AnimatedScroll = parent => {
  const elementNodes = parent.querySelectorAll('.animated');

  scroll(
    progress => {
      const factor = progress.y.progress;

      if (factor < 1) {
        elementNodes.forEach((el) => {
          let xTransform = el.dataset.fromX * factor;
          let yTransform = el.dataset.fromY * factor;

          el.style.transform = `translate(${xTransform}px, ${yTransform}px)`;
        });
      }
    },
    {
      target: parent,
      offset: ["start 0.3", "start end"],
    }
  );
};

export default AnimatedScroll;